// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { UserService } from '@daml.js/utility-collateral-app-v1/lib/Utility/Collateral/App/Service/User';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useLedgerEnd } from '../../ledger/useLedgerEnd';
import { useOperatorParty } from '../../utility-operator/useOperatorParty';

const useUserServices: () => UseQueryResult<TemplateContract<UserService>[], string> = () => {
  const ledgerApi = useLedgerApiClient();
  const operator = useOperatorParty()?.data;
  const offset = useLedgerEnd();

  return useQuery({
    enabled: !!(operator && offset),
    queryKey: ['queryCollateralUserServices', ledgerApi, operator, offset],
    queryFn: async () => {
      if (!offset || !operator) {
        return Promise.resolve([]);
      }
      return ledgerApi.queryCollateralUserServices(offset, operator);
    },
    refetchInterval: false,
  });
};

export default useUserServices;
